//@config
export default {
  interview: {
    base: "v1/interview",
    interview_senior_master: "v1/interview/senior_master/{0}",
    question_suggest: "v1/question_suggest",
    question_suggest_id: "v1/question_suggest/{0}",
    my_question_suggest: "v1/my-question-suggest",
    my_question_suggest_id: "v1/my-question-suggest/{0}",
    question_suggest_evaluation: "v1/question_suggest/{0}/evaluation",
    help: "v1/help",
    interview_k_help: "v1/help/interview_k_help",
    interview_m_help: "v1/help/interview_m_help",
    interview_p_help: "v1/help/interview_p_help",
    interview_v_help: "v1/help/interview_v_help",
    interview_location: "v1/interview_location",
    interview_location_plan: "v1/interview_location_plan",
    interview_location_combo: "v1/interview_location_combo",
    interview_doing: "v1/interview_doing/{0}",
    interview_accepting: "v1/interview_accepting/{0}",
    interview_planing_show: "v1/interview_planing_show",
    interviewLocationPerson: "v1/interview_location_person",
    interviewLocationPersonMaster: "v1/interview_location_plan/{0}/masters",
    interviewLocationPersonAudience: "v1/interview_location_plan/{0}/audiences",
    interview_audience_person: "v1/interview/audience_person",
    interview_done: "v1/interview_done",
    interview_start: "v1/interview_start/{0}",
    interview_location_plan_id: "v1/interview_location/{0}/plan",
    person_final_report: "v1/interview_final_result",
    interview_final_result: "v1/parvandeh/{0}/interview_final_result_user",
    parvandeh_interview_final_result: "v1/parvandeh/{0}/interview_final_result",
    research_person_combo: "v1/research_person?search_txt={1}",
    interview_ready: "v1/interview_ready",
    import_interview_location_person:
      "v1/interview_ready/import_interview_location_person",
    interview_person_combo:
      "v1/interview_person?person_kind={0}&search_txt={1}",
    azmoon_execute_combo: "v1/azmoon_execute_combo",
    azmoon_execute_person_reference:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
    interviewDoneAttachment: "v1/interview_done_attachment/{0}",
  },
};
